var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLabel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7982 6.62494H16.5482M15.7982 7.37494H16.5482M19.1734 2H11.9957C11.465 2 10.9561 2.21089 10.581 2.58625L2.58532 10.5872C1.80526 11.3678 1.80484 12.6327 2.58437 13.4137L9.74065 20.5844C10.5209 21.3662 11.7872 21.3675 12.5691 20.5872L20.5862 12.586C20.9622 12.2108 21.1735 11.7015 21.1735 11.1704L21.1734 3.99999C21.1734 2.89542 20.278 2 19.1734 2ZM17.1735 7C17.1735 7.55228 16.7257 8 16.1735 8C15.6212 8 15.1735 7.55228 15.1735 7C15.1735 6.44772 15.6212 6 16.1735 6C16.7257 6 17.1735 6.44772 17.1735 7Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel);
export default __webpack_public_path__ + "static/media/label.346299717e10806a63b40e928e9bbf7b.svg";
export { ForwardRef as ReactComponent };